import { Box, Chip, Typography } from "@mui/material";
import { CarbonCreditProgramme } from "../../types";

type Props = {
  title: string;
  certifications: Array<CarbonCreditProgramme>;
};

export function ReadOnlyCertifications({ title, certifications }: Props) {
  if (!certifications || certifications.length === 0) {
    return (
      <Typography align="left" variant="subtitle2">
        {`No ${title} assigned`}
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
      }}
    >
      <Typography variant="subtitle2" sx={{ paddingBottom: 0.5 }}>
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "start",
          gap: 0.5,
        }}
      >
        {certifications?.map((certificate) => (
          <Chip
            key={certificate}
            sx={{
              backgroundColor: "grey",
              color: "black",
              fontWeight: 600,
            }}
            label={certificate}
          />
        ))}
      </Box>
    </Box>
  );
}
